import './index.scss'
export { ArtworkManagement } from './pages/artwork-management';